
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_fvjdu_1wdgv_9",
  "button": "awsui_button_fvjdu_1wdgv_50",
  "dots": "awsui_dots_fvjdu_1wdgv_51",
  "button-disabled": "awsui_button-disabled_fvjdu_1wdgv_79",
  "arrow": "awsui_arrow_fvjdu_1wdgv_84",
  "page-number": "awsui_page-number_fvjdu_1wdgv_94",
  "button-current": "awsui_button-current_fvjdu_1wdgv_100",
  "jump-to-page": "awsui_jump-to-page_fvjdu_1wdgv_113",
  "jump-to-page-input": "awsui_jump-to-page-input_fvjdu_1wdgv_121",
  "pages-compact": "awsui_pages-compact_fvjdu_1wdgv_131",
  "page-item": "awsui_page-item_fvjdu_1wdgv_136",
  "root-disabled": "awsui_root-disabled_fvjdu_1wdgv_157"
};
  